export const CONTROLS_DEFAULT = 150;
export const CONTROLS_MIN = 60;
export const CONTROLS_STEP = 15;
export const ZOOM_STEP = 300;
export const HEADER_HEIGHT = 53;

export function getPinchDistance(touches: TouchList): number {
  const t0 = touches.item(0);
  const t1 = touches.item(1);

  if (!t0 || !t1) return 0;

  return Math.hypot(t1.clientX - t0.clientX, t1.clientY - t0.clientY);
}

export function getBaseZoom(
  size: string,
  controls: number,
  imgEl: HTMLImageElement | null,
  zoom: number,
): number {
  return size === "MODAL" && controls === CONTROLS_DEFAULT && imgEl
    ? imgEl.clientWidth
    : zoom;
}

export function getViewportCenterNorm(
  content: HTMLElement,
  hViewport: HTMLElement,
  vViewport: HTMLElement,
): { normX: number; normY: number } {
  const contentRect = content.getBoundingClientRect();
  const hRect = hViewport.getBoundingClientRect();
  const vRect = vViewport.getBoundingClientRect();
  const centerX = hRect.left + hRect.width / 2;
  const centerY = vRect.top + vRect.height / 2;

  return {
    normX: (centerX - contentRect.left) / contentRect.width,
    normY: (centerY - contentRect.top) / contentRect.height,
  };
}

export function zoomAroundPoint(
  content: HTMLElement,
  hScroller: HTMLElement,
  vScroller: HTMLElement,
  normX: number,
  normY: number,
  newZoom: number,
  newControls: number,
  applyZoom: (zoom: number, controls: number) => void,
): void {
  const safeZoom = Number.isFinite(newZoom)
    ? Math.max(newZoom, 1)
    : content.clientWidth;
  const oldWidth = content.clientWidth;
  const oldHeight = content.clientHeight;

  content.style.width = `${safeZoom}px`;
  const newHeight = content.clientHeight;
  const safeNormX = Number.isFinite(normX) ? normX : 0.5;
  const safeNormY = Number.isFinite(normY) ? normY : 0.5;

  hScroller.scrollLeft += safeNormX * (safeZoom - oldWidth);
  vScroller.scrollTop += safeNormY * (newHeight - oldHeight);

  applyZoom(safeZoom, newControls);
}
